import { Accordion, AccordionItem } from '@design-system';
import { labelToSlug } from '@utils/slug';
import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';
import SbEditable from 'storyblok-react';
import { render } from 'storyblok-rich-text-react-renderer';

import ScrollAnchor from '../../ScrollAnchor';

type Props = {
  blok: SupportBlock;
};

const SupportBlock: React.FC<Props> = ({ blok }) => {
  if (blok.isAccordion) {
    return <AccordionBlock blok={blok} />;
  }

  return (
    <div className="rich-text-content relative pb-2 pt-2">
      {/* @ts-expect-error require storyblok-react upgrade */}
      <SbEditable key={blok._uid} content={blok}>
        <DefaultBlock blok={blok} />
      </SbEditable>
    </div>
  );
};

const AccordionBlock: React.FC<Props> = ({ blok }) => {
  const router = useRouter();
  const ref = useRef<HTMLAnchorElement>(null);
  const anchor = router.asPath.includes('#')
    ? router.asPath.split('#')[1]
    : null;

  useEffect(() => {
    if (anchor && ref.current && anchor === labelToSlug(blok.title)) {
      ref.current.scrollIntoView();
    }
  }, [anchor, ref.current]);

  function handleAnchorClick() {
    const currentUrl = new URL(window.location.href);

    router.push(
      `${currentUrl.pathname + currentUrl.search}#${labelToSlug(blok.title)}`,
      undefined,
      { shallow: true },
    );
  }

  return (
    <div className="supportBlock [&_+_*]:divide-y [&_+_*]:divide-divider/20">
      <ScrollAnchor ref={ref} id={labelToSlug(blok.title)} offset={-72} />
      <Accordion>
        <AccordionItem
          key={crypto.randomUUID()}
          anchorClick={handleAnchorClick}
          isOpen={anchor === labelToSlug(blok.title)}
          subject={render(blok.title)}
        >
          {render(blok.text)}
        </AccordionItem>
      </Accordion>
    </div>
  );
};

const DefaultBlock: React.FC<Props> = ({ blok }) => {
  return (
    <div>
      <div className="mb-2 pt-1 font-bold">{render(blok.title)}</div>
      {render(blok.text)}
    </div>
  );
};

export default SupportBlock;
